<template>
  <b-modal id="bv-modal-edit-chapter" size="xl" hide-footer centered>
    <template v-slot:modal-title>
      Edit Chapter
    </template>
    <b-form @submit.prevent="editChapter">

      <b-form-group
        id="chapter-title-group"
        label="Chapter Title"
        label-for="chapter-title"
      >
        <b-form-input
          id="chapter-title"
          v-model="editForm.title"
          type="text"
          required
          placeholder="Enter a title"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="monitor-pdf-group"
        label="Upload PDF Research"
        label-for="monitor-pdf"
      >
        <b-form-file
          id="monitor-pdf"
          v-model="editForm.pdf"
          placeholder="Choose a file or drop it here..."
          ref="monitorImage"
          @change="onFileChange"
        ></b-form-file>
      </b-form-group>

      <template v-if="uploadedPdfName">
        <p>Current file: {{ uploadedPdfName }}</p>
      </template>

      <b-form-group
        id="monitor-image-group"
        label="Image"
        label-for="monitor-image"
      >
        <b-form-file
          id="monitor-image"
          v-model="editForm.image"
          placeholder="Choose an image or drop it here..."
          ref="monitorImage"
          @change="onImageChange"
        ></b-form-file>
      </b-form-group>

      <b-row v-if="uploadedImageUrl" class="mb-3">
        <b-col cols="12" sm="6">
          <img :src="uploadedImageUrl" class="img-fluid" />
        </b-col>
      </b-row>

      <b-row class="row--less-gutters mb-4">

        <b-col cols="3" v-if="monitorCategory === 'consumer'">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-consumer-group"
              label="Insights"
              label-for="monitor-tags-consumer"
              v-if="monitorConsumerInsightsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-consumer"
                v-model="editForm.insights"
                :options="monitorConsumerInsightsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3" v-if="monitorCategory === 'market'">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-market-group"
              label="Sectors"
              label-for="monitor-tags-market"
              v-if="monitorMarketInsightsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-market"
                v-model="editForm.insights"
                :options="monitorMarketInsightsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-generations-group"
              label="Generations"
              label-for="monitor-tags-generations"
              v-if="monitorConsumerGenerationsOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-generations"
                v-model="editForm.generations"
                :options="monitorConsumerGenerationsOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-geolocalization-group"
              label="Geolocalization"
              label-for="monitor-tags-geolocalization"
              v-if="monitorGeolocalizationOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-geolocalization"
                v-model="editForm.geolocalizations"
                :options="monitorGeolocalizationOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

        <b-col cols="3">
          <div class="monitor-tags-group">
            <b-form-group
              id="monitor-tags-gender-group"
              label="Gender"
              label-for="monitor-tags-gender"
              v-if="monitorGenderOptions.length"
            >
              <b-form-checkbox-group
                id="monitor-tags-gender"
                v-model="editForm.genders"
                :options="monitorGenderOptions"
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </b-col>

      </b-row>

      <b-alert
        :variant="alert.type"
        dismissible
        fade
        :show="alert.show"
        @dismissed="alert.show=0"
        @dismiss-count-down="alertCountDownChanged"
      >
        {{ alert.content }}
      </b-alert>

      <div class="text-right">
        <b-button type="submit" variant="primary"><b-spinner small variant="light" v-if="isLoading"></b-spinner> Edit</b-button> 
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { monitorsDataMixin } from '../mixins/monitorsDataMixin.js';

import {
  MONITOR_CHAPTER_EDIT
} from "@/store/actions.type";

export default {
  name: 'MonitorChapterEdit',
  props: ['chapter'],
  mixins: [monitorsDataMixin],
  data() {
    return {
      isLoading: false,
      tagsCheckboxes: [],
      editForm: {
        title: '',
        pdf: null,
        image: null,
        insights: [],
        generations: [],
        geolocalizations: [],
        genders: []
      },
      uploadedPdfName: '',
      uploadedImageUrl: '',
      alert: {
        show: 0,
        type: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapGetters(["monitorTags", "monitorCategory", "monitorCurrent"]),
    formTags: function() {
      if(this.monitorCategory == 'consumer') {
        return this.monitorConsumerGenerations
      } else {
        return this.monitorMarketInsights
      }
    }
  },
  methods: {
    alertCountDownChanged(dismissCountDown) {
      this.alert.show = dismissCountDown
    },
    editChapter() {

      if(!this.validateChapterData()) {
        return
      }

      this.isLoading = true;

      let chapterData = new FormData();
      chapterData.set('name', this.editForm.title);
      if(this.editForm.pdf) {
        chapterData.set('pdf_research', this.editForm.pdf);
      }
      if(this.editForm.image) {
        chapterData.set('chapter_picture', this.editForm.image);
      }

      let i = 0;
      for (i = 0; i < this.editForm.insights.length; i++) {
        chapterData.append('insights', this.editForm.insights[i]);
      }
      for (i = 0; i < this.editForm.generations.length; i++) {
        chapterData.append('generations', this.editForm.generations[i]);
      }
      for (i = 0; i < this.editForm.geolocalizations.length; i++) {
        chapterData.append('geolocalizations', this.editForm.geolocalizations[i]);
      }
      for (i = 0; i < this.editForm.genders.length; i++) {
        chapterData.append('genders', this.editForm.genders[i]);
      }

      let payload = {
        monitorId: this.monitorCurrent.monitor.id,
        chapterId: this.chapter.id,
        chapterData: chapterData
      }

      this.$store.dispatch(MONITOR_CHAPTER_EDIT, payload).then(() => {
        this.$bvModal.hide('bv-modal-edit-chapter');
        this.$bvToast.toast(`Chapter ${this.editForm.title} has been edited successfully`, {
          title: 'Chapter edited',
          toaster: 'b-toaster-bottom-right',
          autoHideDelay: 4000,
          variant: 'primary'
        });
        this.resetForm();
        this.isLoading = false;
        this.$emit('chapterEdited');
      });
    },
    validateChapterData() {
      if(this.editForm.insights == 0 || this.editForm.generations == 0 || this.editForm.geolocalizations == 0 || this.editForm.genders == 0) {
        this.alert.show = 3;
        this.alert.type = 'danger';
        this.alert.content = 'You must select at least one generation, insight, geolocalization and gender';
        this.isLoading = false;
        return false
      } else {
        return true
      }
    },
    resetForm() {
      this.editForm.title = '';
      this.editForm.pdf = null;
      this.editForm.image = null;
      this.editForm.insights = [];
      this.editForm.generations = [];
      this.editForm.geolocalizations = [];
      this.editForm.genders = [];
      this.uploadedPdfName = '';
      this.uploadedImageUrl = '';
    },
    onFileChange(e) {
      this.uploadedPdfName = e.target.files[0].name;
    },
    onImageChange(e) {
      const file = e.target.files[0];
      this.uploadedImageUrl = URL.createObjectURL(file);
    }
  },
  mounted() {
    
  },
  watch: {
    chapter: function() {
      this.editForm.id = this.chapter.id;
      this.editForm.title = this.chapter.name;
      if(this.chapter.pdf_research) {
        this.uploadedPdfName = this.chapter.pdf_research;
      } else {
        this.uploadedPdfName = '';
      }
      if(this.chapter.chapter_picture) {
        this.uploadedImageUrl = this.chapter.chapter_picture;
      } else {
        this.uploadedImageUrl = '';
      }
      this.editForm.insights = this.chapter.insights;
      this.editForm.generations = this.chapter.generations;
      this.editForm.geolocalizations = this.chapter.geolocalizations;
      this.editForm.genders = this.chapter.genders;
    }
  }
}
</script>